import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom'
import { v4 as uuid } from "uuid";
import Select from "react-select";
import axiosinstances from '../../Helper/useAxios'

export default function RechargeRouting() {
    const navigate = useNavigate();
    const id = useSelector((state) => state.getprofilereducer?.getprofile?.id);
    const newId = id
    const unique_id = uuid();
    const [axiosInstance] = axiosinstances()
    const [selectedRecharge, setSelectedRecharge] = useState([]);
    const [profileDetails,setProfileDetails] = useState()
    const profileId = useParams()
    const [permissionOption, setPermissionOption] = useState([{value:"MOBILE", label:'mobile'},{value:"OTT", label:'ott'},{value:"DTH", label:'dth'},]);
    const [isupdateRouting, setIsupdateRouting] = useState(false)
    const [dmtDetails, setDmtDetails]= useState({
        id:profileId?.id,
       // name: profileDetails?.businessInfo?.name !== undefined ? profileDetails?.businessInfo?.name : '',
        async:false,
        orderStatusCallback:'',
        defaultSupplierId:{},
        tpsAccEnabled: false,
        tpsAccUrl:{}
    })
//console.log('SelectedRecharge', selectedRecharge)
//console.log('profileDetails', profileDetails)
    const token=JSON.parse(sessionStorage.getItem('token'))
    const  getprofileserviicesresponse = (data) => {
		return  axiosInstance
		.get(`/api/v1/retailer/get/${profileId.id}`,{ headers: {"Authorization" : `Bearer ${token}`,"client-id":newId,"role":"ROLE_RETAILER_FINXPAY"}})
		.then(response => {
			if (response) {
				//console.log('res', response)
				const { data } = response
                //console.log('dada', data)
				setProfileDetails(data)
                setDmtDetails((prev)=>({
                    ...prev,
                   name: data?.businessInfo?.name !== undefined ? data?.businessInfo?.name : ''
                }))
			}
			return false
		})
	   .catch((err) => {
		 //console.log(err);
	   });
		
	}

    const  getDmtroutingresponse = (data) => {
		return  axiosInstance
		.get(`/api/v1/vas/client-routing/admin/get/${profileId.id}`,{ headers: {"Authorization" : `Bearer ${token}`,"client-id":newId,"role":"ROLE_RETAILER_FINXPAY"}})
		.then(response => {
        
			if (response.status == 200) {
				//console.log('res routing', response)
                setIsupdateRouting(true) 
				const { data } = response
                const values = Object.keys(data.defaultSupplierId)
              //  setSelectedRecharge(values)
              //console.log('valuessss',values)
              const finalSelectedValues = values !== undefined && values.length > 0 && values.map((val, index)=>({value:val, label:val.toLowerCase()}))
              setSelectedRecharge(finalSelectedValues)
              //setProfileDetails(data)

                setDmtDetails((prev)=>({
                    ...prev,
                  ...data
                }))
			} else if(response.status == 500) {
                setIsupdateRouting(false)  
            }
          
			return false
		})
	   .catch((err) => {
		 //console.log(err);
	   });
		
	}
    const profileDetailsPage = () =>{
        navigate(`/profile/${profileId?.id}`)
      }
	useEffect(()=>{
    if(id!== undefined ){
        getprofileserviicesresponse()
        getDmtroutingresponse()
    }
	},[id])
    const handleChange =(e) =>{
     let {value, name} = e.target
     if(value == 'true'){
        value = true
     } else if(value==='false'){
        value = false
     }

     setDmtDetails((prev)=>(
        {
            ...prev, [name]:value
        }
     ))
    } 
    //console.log('dmtDetails', dmtDetails)
    const rechargeHandleChange = (e) =>{
        let {value, name} = e.target
        setDmtDetails((prev)=>(
            {
                ...prev, defaultSupplierId:{...prev.defaultSupplierId, [name]:value}
            }
         ))
    }
    const tcpChange = (e) =>{
        const {value, name} = e.target
        const urlValue = dmtDetails.tpsAccUrl !== null ? dmtDetails.tpsAccUrl : {}
            urlValue[name] = value
            setDmtDetails((prev)=>({
            ...prev,
            tpsAccUrl:urlValue
        }))
    }
    const stylesofStype = {
        //container
    
        control: (styles) => ({
          ...styles,
          backgroundColor: "none",
          borderColor: "none",
          border: "none",
          padding: "0px",
          borderRadius: "0px",
          minHeight: "16px",
          boxShadow: "none",
          fontSize: "16px",
          // border: state.isFocused && "none"
        }),
        valueContainer: (styles) => ({
          ...styles,
          backgroundColor: "none",
          border: "none",
          padding: "0px",
          borderRadius: "0px",
          
        }),
        multiValue: (styles) => ({ ...styles, lineHeight: "16px" }),
        //IndicatorsContainer
        input: (styles) => ({ ...styles, padding: "0px", margin: "0px" }),
        //singleValue
        singleValue: (styles) => ({ ...styles, fontSize: "14px" }),
      };
      const changeHandler = (select) =>{
        //console.log('select', select)
        setSelectedRecharge(select)
      }
    const date = new Date()
    const createUser = async (roId) => {
		const url = isupdateRouting ?  `/api/v1/vas/client-routing/admin/update` : `/api/v1/vas/client-routing/admin/create`
        const response = await axiosInstance
        .post(url,
        {
        ...dmtDetails
        },{
                headers: {
                  Authorization: `Bearer ${token}`,
                  "client-id": id,
                   role: "ROLE_RETAILER_FINXPAY",
                } })
       .then((res) => {
        //console.log('user created res-->', res)
        if(res.status == 200){
          profileDetailsPage()
          }
         
       })
       .catch((err) => {
         //console.log(err);
         
       });
    
        if (response) {
          const result = response.data.orders;
          
          if (result) {
          }
    
          return response.data;
        }
        return false;
      }; 
  const handleSubmit =(e)=>{
    e.preventDefault()
    createUser()
  }
  const defaultSupplierValue =(check)=>{
   const keys = Object.keys(dmtDetails.defaultSupplierId)
  let testArray = check in dmtDetails.defaultSupplierId;
  //console.log('testArray', testArray, check)
  if(testArray){
    const newVal = dmtDetails.defaultSupplierId[check]
    //console.log('newVal', newVal, check)
   return newVal 
  } else{
    return ''
  }
  }
    return (
    <div class="mid-contant">
	<div class="container">		
		<div class="row">
			<div class="col-12">
				<div class="head">
                <h2>VAS Routing <span style={{fontSize:18, fontWeight:400}}>(client's name/id - {profileDetails?.businessInfo?.name !== undefined ? profileDetails?.businessInfo?.name : ''} - {profileId?.id})</span> </h2> 
				</div>
			</div>
			
			<div class="col-12">
				<div class="registerbox">
					<div class="row mb-3">
						<div class="col-12 col-lg-7">
							<form onSubmit={handleSubmit}  >
							<div class="row">								
                           
								
								<div class="col-12 col-md-6">
									<div class="form-floating">
										<input type="text" class="form-control" id='ocall'  placeholder="Enter Order status Call" name='orderStatusCallback' onChange={handleChange} value={dmtDetails.orderStatusCallback} />
										<label for="ocall">Client Callback URL</label>
										{/* {personalDetails.personalInfo.lname.length > 2 && isLnameCorrect &&	<small style={{color:'red'}} >Enter Valid Last Name</small>} */}
									</div>
								</div>
								
								{/* <div class="col-12 col-md-6">
									<div class="form-floating">
										<input type="text" class="form-control" id="dsid" placeholder="Enter Default Supplier Id" name='defaultSupplierId' onChange={handleChange} value={dmtDetails.defaultSupplierId} />
										<label for="dsid">Default Supplier Id</label>
					
										{/* {personalDetails.personalInfo.mobile.length > 1 && isMobileCorrect &&	<small style={{color:'red'}} >Enter Valid Mobile Number</small>} */}
									{/* </div>
								</div> */} 
                                <div className="col-12 col-md-6">
                    <div className="form-row">
                      <div className="formselect">
                        <label>Service Type</label>
                        <Select
                          className="basic-multi-select"
                          styles={stylesofStype}
                          closeMenuOnSelect={false}
                          components={{
                            IndicatorsContainer: () => null,
                            IndicatorSeparator: () => null,
                          }}
                          isMulti
                          options={permissionOption}
                          onChange={changeHandler}
                          value ={selectedRecharge}
                          placeholder =" select multiple option"
                        />
                      </div>
                    </div>
                  </div>
								
				{
                    selectedRecharge.length > 0 && 
                    selectedRecharge.map((value, index)=>{
                        return <div class="col-12 col-md-6">
                        <div class="form-floating">
                            <input type="text" class="form-control" id={`rech${index}`}   placeholder={`Enter ${value?.label}`} name={`${value?.value}`} onChange={rechargeHandleChange} value={defaultSupplierValue(value?.value)} />
                            <label for={`rech${index}`}>{`${value?.value} Supplier Id`}</label>
                            {/* {personalDetails.personalInfo.lname.length > 2 && isLnameCorrect &&	<small style={{color:'red'}} >Enter Valid Last Name</small>} */}
                        </div>
                    </div>
                    })
                }
								
								<div class="col-12 col-md-6">
									<div class="form-floating">
										<select class="form-select"  id="async" name='async' onChange={handleChange} value={dmtDetails.async} >
											<option value="">Select</option>
											<option value={true}>Yes</option>
											<option value={false}>No</option>
										</select>
										<label for="async">Async</label>
									</div>
								</div>						
								
								<div class="col-12 col-md-6">
									<div class="form-floating">
										<select class="form-select"  id="tpsAccEnabled" name='tpsAccEnabled' onChange={handleChange} value={dmtDetails.tpsAccEnabled} >
											<option value="">Select</option>
											<option value={true}>Yes</option>
											<option value={false}>No</option>
										</select>
										<label for="tpsAccEnabled">3rd Party Accounting Enabled</label>
									</div>
								</div>
								
                                {
                                    dmtDetails.tpsAccEnabled && 
                                    <div class="col-12 col-md-6">
									<div class="form-floating">
										<input type="text" class="form-control" id="debit" placeholder="Enter Debit url"  name='debit' onChange={tcpChange} value={dmtDetails?.tpsAccUrl?.debit !== undefined ? dmtDetails?.tpsAccUrl?.debit : ''} />
										<label for="debit">Debit URL</label>
										{/* { personalDetails.personalInfo.email.length > 3 && isEmailCorrect &&	<small style={{color:'red'}} >Enter Valid Email id</small>} */}
									</div>
								</div>
                                }
                                
                                {
                                  dmtDetails.tpsAccEnabled && <div class="col-12 col-md-6">
                                  <div class="form-floating">
                                      <input type="text" class="form-control" id="refund" placeholder="Enter Refund url" name='refund' onChange={tcpChange} value={dmtDetails?.tpsAccUrl?.refund !== undefined ? dmtDetails?.tpsAccUrl?.refund : ''}   />
                                      <label for="refund">Refund URL</label>
                                      {/* { personalDetails.personalInfo.email.length > 3 && isEmailCorrect &&	<small style={{color:'red'}} >Enter Valid Email id</small>} */}
                                  </div>
                              </div>  
                                }

                                {
                                   dmtDetails.tpsAccEnabled &&  
                                   <div class="col-12 col-md-6">
									<div class="form-floating">
										<input type="text" class="form-control" id="enquiry" placeholder="Enter Enquiry" name='enquiry' onChange={tcpChange} value={dmtDetails?.tpsAccUrl?.enquiry !== undefined ? dmtDetails?.tpsAccUrl?.enquiry : ''}  />
										<label for="enquiry">Enquiry URL</label>
										{/* { personalDetails.personalInfo.email.length > 3 && isEmailCorrect &&	<small style={{color:'red'}} >Enter Valid Email id</small>} */}
									</div>
								</div> 
                                }
                                
                                

								<div class="col-12">
									<button  type="submit" class="btn btn-primary" id="">Proceed</button>
								</div>								
							</div>
							</form>							
						</div>
						
						<div class="col-12 col-lg-5 d-none d-lg-block">
							<div class="rightbanner"><img src={require('../../assests/images/register.png')} alt="Oxigen" class="img-fluid"/></div>
						</div>				
					</div>
				</div>
			</div>
		</div>
	</div>
    </div>
  )
}
